import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Party detail -- `/parties/$partyId`. Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/parties/$partyId",
	component: lazyRouteComponent(() => import("./$partyId.page")),
})
